import { Link } from "react-router-dom";
import type { WorkItem } from "@/mocks/works";
import { workTypeMap } from "@/mocks/works";

interface WorkCardProps {
  item: WorkItem;
}

export default function WorkCard({ item }: WorkCardProps) {
  return (
    <Link
      to={`/works/${item.id}`}
      className="group flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer h-full"
    >
      <div className="w-full aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 小泽玛利亚影视作品`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-3 md:p-4">
        <div className="flex items-center gap-2 mb-1.5">
          <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-900 whitespace-nowrap">
            {workTypeMap[item.type]}
          </span>
          <span className="text-xs text-foreground-500">{item.year}</span>
        </div>
        <h3 className="font-heading text-base font-semibold text-foreground-950 leading-snug line-clamp-1 group-hover:text-primary-700 transition-colors">
          {item.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 line-clamp-1">导演：{item.director}</p>
      </div>
    </Link>
  );
}